export default __webpack_public_path__ + "ca515c2e31fdcb9f1177c6fe5f755c6f.jpeg";